const e=async(e,t,n)=>{let{data:r}=await e.delete(`/apps/${t}/terms/${n}`);return r};export{e as deleteTerms};
//# sourceMappingURL=delete-terms.mjs.map